module.exports = __webpack_public_path__ + "img/no-image.f1b5e004.jpg";